@if (formControl() && items()?.length) {
<div class="content-picker form-group" [formGroup]="formGroup()!">
    <div class="search">
        <mat-form-field class="form-field">
            <input #search matInput [readonly]="meta()?.readonly || readonly()" [placeholder]="$safeNavigationMigration(meta()?.name)"
                class="form-control input-date" [formControl]="formControl()!" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onPick($event)">
                @for (group of filtered | async; track $index) {
                <mat-optgroup [label]="group.key">
                    @for (item of group.items; track item._id) {
                    <mat-option [value]="item">
                        {{item.name}}
                    </mat-option>
                    }
                </mat-optgroup>
                }
            </mat-autocomplete>
            <mat-hint>
                <strong>
                    {{meta()?.info}}
                    {{meta()?.min || meta()?.max ? ' - ' : undefined}}
                    {{meta()?.min ? 'min ' + meta()?.min + (meta()?.min > 1 ? ' items' : ' item') : undefined}}
                    {{meta()?.max ? 'max ' + meta()?.max + (meta()?.max > 1 ? ' items' : ' item') : undefined}}
                    {{meta()?.min || meta()?.max ? ' allowed' : undefined}}
                </strong>
            </mat-hint>
            @if (formControl()?.hasError('picker')) {
            <mat-error>
                {{meta()?.name}} is required.
            </mat-error>
            }
            @if (formControl()?.hasError('picker_min')) {
            <mat-error>
                Minimum {{meta()?.min}} {{ meta()?.min > 1 ? 'items' : 'item'}} allowed.
            </mat-error>
            }
            @if (formControl()?.hasError('picker_max')) {
            <mat-error>
                Maxinum {{meta()?.max}} {{ meta()?.max > 1 ? 'items' : 'item'}} allowed.
            </mat-error>
            }
        </mat-form-field>
    </div>
    <div class="contents" [formArray]="pickerArray!">
        @for (content of nodes; track content._id; let i = $index) {
        <div class="content">
            @if (!!content) {
            <mat-form-field class="form-field">
                <input readonly matInput [formControl]="$any($safeNavigationMigration(pickerArray?.at(i)))">
                <button matSuffix mat-icon-button aria-label="Clear" [disabled]="readonly()" (click)="onDelete(i)">
                    <mat-icon>close</mat-icon>
                </button>
                <mat-hint><strong>{{content.prototype?.name}} - {{content.name}}</strong></mat-hint>
            </mat-form-field>
            }
        </div>
        }
    </div>
</div>
}
